package amazon.lastmile.inject

import app.nestbridge.feature.common.ui.DocumentUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DocumentUiFactory::class)
public interface AppNestbridgeFeatureCommonUiDocumentUiFactory {
  @Provides
  @IntoSet
  public fun provideDocumentUiFactoryFactoryMultibinding(documentUiFactory: DocumentUiFactory): Ui.Factory = documentUiFactory
}
